import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import AddForm from "./addForm";
import {
  useGetBrandsQuery,
  useAddBrandsMutation,
  useDeleteBrandsMutation,
  useUpdateBrandsMutation,
} from "slices/eCommerce/brandSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Brands() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [add] = useAddBrandsMutation();
  const [update] = useUpdateBrandsMutation();
  const [del] = useDeleteBrandsMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetBrandsQuery({
    page,
    limit,
    search,
  });
  const col = [
    { display: "Name", key: "name", type: "display" },
    {
      display: "Image",
      key: "image",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
  ];

  const canEdit = hasActionAccess(auth, "E-Commerce", "Brands", "edit");
  const canDelete = hasActionAccess(auth, "E-Commerce", "Brands", "delete");
  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };
  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this brand?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    console.log("dataaaaa", data);
    try {
      let formData = new FormData();
      formData.append("name", data.name);
      formData.append("metaTitle", data.metaTitle);
      formData.append("metaDescription", data.metaDescription);
      formData.append("category", data.category);

      // Only append image if it is a File (i.e., user selected a new one)
      if (data.image instanceof File) {
        formData.append("image", data.image);
      }
      if (data.keywords.length > 0) {
        for (let index = 0; index < data.keywords.length; index++) {
          formData.append("keywords", data.keywords[index]);
        }
      }

      if (editing) {
        await update({ id: data._id, body: formData }).unwrap();
        refetch();
      } else {
        await add(formData).unwrap();
        refetch();
      }

      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null); // <-- Clear editing data
  };

  const canAdd = hasActionAccess(auth, "E-Commerce", "Brands", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddForm
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />
      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Brand
        </Button>
      )}

      <Tables
        title={"Brands"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Brands;
